var _path, _polygon, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestockSupplies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.4,7.5c-1-0.1-1.8,0.6-1.9,1.6v22.5l2.5,5.5l0,0c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.7-0.1,0.9-0.3l0,0 l2.4-5.5c0.1-0.1,0.1-0.1,0.1-0.2V9.1c-0.1-1-1-1.7-2-1.6c0,0,0,0,0,0H9.4z M12.2,8.3c0.7,0,1.2,0.4,1.2,0.8v3H8.3v-3 c0-0.4,0.5-0.8,1.1-0.8H12.2z M8.3,12.9h2.2v18H8.3V12.9z M12,34.5H9.7l-1.3-2.9h4.9L12,34.5z M13.4,30.9h-2.2v-18h2.2V30.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "8.4,31.6 9.7,34.5 12,34.5 13.3,31.6 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 12.9,
    fill: "#FFDEAF",
    width: 2.2,
    height: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 12.9,
    fill: "#FFDEAF",
    width: 2.2,
    height: 18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA908A",
    d: "M8.3,9.1v3h5.1v-3c0-0.4-0.5-0.8-1.2-0.8H9.4C8.8,8.3,8.3,8.7,8.3,9.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.1,7.5H16.6c-0.2,0-0.4,0.2-0.4,0.4v29.2c0,0.2,0.2,0.4,0.4,0.4h20.5c0.2,0,0.4-0.2,0.4-0.4V7.9 C37.5,7.7,37.3,7.5,37.1,7.5z M36.7,36.7H16.9V8.3h19.8V36.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.9,8.3v28.4h19.8V8.3H16.9z M20.8,30.7c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,31.1,20.8,30.9,20.8,30.7z M20.8,26.6c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,27,20.8,26.8,20.8,26.6z M20.8,22.5c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 s-0.2,0.4-0.4,0.4H21.1C20.9,22.9,20.8,22.7,20.8,22.5z M20.8,18.4c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,18.8,20.8,18.6,20.8,18.4z M20.8,14.3c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,14.7,20.8,14.5,20.8,14.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5,31.1c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4s0.1,0.4,0.3,0.4H32.5z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5,27c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4s0.1,0.4,0.3,0.4H32.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5,22.9c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.1,0.4,0.3,0.4 L32.5,22.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5,18.8c0.2,0,0.4-0.2,0.4-0.4S32.7,18,32.5,18H21.1c-0.2,0-0.3,0.2-0.3,0.4s0.1,0.4,0.3,0.4H32.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5,14.7c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.1,0.4,0.3,0.4 H32.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestockSupplies);
export default __webpack_public_path__ + "static/media/restock_supplies.155324ca7feca38637e5bf1fc7026018.svg";
export { ForwardRef as ReactComponent };